<template>
  <div v-if="visible"></div>
</template>

<script>
import {
  reducer, w, canWriteStorage
} from '../utils/helpers'
import ls from '../utils/storage'

//white list of state to save in store
const paths = []
//if storage is cookie base add a whitelist for only the following
if (ls.isCookie)
  paths.push(
    'uid',
    'assigned'
  )

export default {
  created() {

    //console.log('frameStorage init server')
    window.addEventListener('message', this.listen)
    this.send('connect')

  },
  data() {
    return {
      storageKey: null
    }
  },
  methods: {
    send(type, data) {

      const payload = {
        swaychat_storage: 'server',
        key: this.storageKey,
        type,
        data
      }

      parent.postMessage(JSON.stringify(payload), '*');

    },
    listen(e) {

      if (!e.data ||
        typeof e.data != 'string' ||
        /swaychat_storage/.test(e.data) == false
      ) return

      const payload = JSON.parse(e.data)

      if (payload.type == 'sync' &&
        payload.key &&
        payload.key == w.key //make sure that only instantiator can sync with us
      )
        this.sync(payload.key)

      if (payload.type == 'update' &&
        payload.key == this.storageKey &&
        payload.data &&
        canWriteStorage(payload.data)
      ) {
        //console.log('payload', payload)
        this.update(payload.key, payload.data)
      }

    },
    sync(key) {
      this.storageKey = key
      const data = ls.getItem(key)
      this.send('sync', data ? JSON.parse(data) : '')

    },
    update(key, data) {
      // console.log('update', data)
      if (key == this.storageKey)
        ls.setItem(this.storageKey, JSON.stringify(reducer(data, paths)))
    }
  }

}
</script>
